
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workout/[workoutId]",
      function () {
        return require("private-next-pages/workout/[workoutId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workout/[workoutId]"])
      });
    }
  